import { ASPExperiment } from './ASPExperiment'

export enum ASP_NEWNESS_VARIATIONS {
  NewnessControl = 'ASPNewnessControl',
  NewnessEnabled5 = 'ASPNewnessEnabled5',
  NewnessEnabled20 = 'ASPNewnessEnabled20',
}

export const ASPNewnessExperimentNewnessPercentage = {
  experimentKey: 'newest_exploration',
  variationsValueMap: {
    [ASP_NEWNESS_VARIATIONS.NewnessControl]: '0',
    [ASP_NEWNESS_VARIATIONS.NewnessEnabled5]: '0.05',
    [ASP_NEWNESS_VARIATIONS.NewnessEnabled20]: '0.20',
  },
} as ASPExperiment
